import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSignupState } from '../../../hooks'
import { clearAllTosStorage } from '../../../lib/tosStateHelpers'
import { useStateData } from '../../../stateData/useStateData'
import { fetchPartialSubscription } from '../../../stateData/partialSubscription'

interface TosCleanupProviderProps {
  children: React.ReactNode
}

export const TosCleanupProvider: FC<TosCleanupProviderProps> = ({
  children
}) => {
  const location = useLocation()

  const shouldFetchPartialSubscription =
    !location.pathname.includes('oobe-exit') &&
    !location.pathname.includes('oobe-sign-in')

  const { data: partialSubscription } = useStateData(
    'partialSubscription',
    fetchPartialSubscription,
    ({ signupSession }) =>
      shouldFetchPartialSubscription &&
      signupSession.partialSubscriptionId !== undefined
  )

  const flowName = partialSubscription?.flowName
  const { signupSession } = useSignupState()
  const { xCorrelationId } = signupSession || {}

  useEffect(() => {
    const currentPath = location.pathname

    if (
      currentPath.includes('thank-you') ||
      currentPath.endsWith('StartStep')
    ) {
      if (xCorrelationId) {
        clearAllTosStorage(xCorrelationId, flowName)
      }
    }
  }, [location.pathname, xCorrelationId, flowName])

  return <>{children}</>
}
